import {
  INSERT_SEARCH_FILTER,
  CLEAR_SEARCH_FILTER,
  UN_SEARCH_FILTER,
} from './constants'

export const insertSearchFilter = searchFilter => ({
  type: INSERT_SEARCH_FILTER,
  searchFilter,
  isClear: false,
})

export const clearSearchFilter = searchFilter => ({
  type: CLEAR_SEARCH_FILTER,
  isClear: true,
})

export const unClearSearchFilter = searchFilter => ({
  type: UN_SEARCH_FILTER,
  searchFilter,
  isClear: false,
})
